import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import React, { PureComponent } from 'react';
import MenuItem from 'components/Menu/MenuItem';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { EMAIL_IS_IN_USE_ERROR, EMAIL_IS_IN_USE_NOTIFICATION } from 'constants/accountEmail';
import {
  removeEmailConfig,
  getAccountEmailConfigs,
  getOrganizationEmailConfigs,
} from 'redux/actions/emailConfigActions';
import EmailConfigDeleteConfirm from './EmailConfigDeleteConfirm';

const parseErrorResponse = (errorMsg) => {
  if (errorMsg === EMAIL_IS_IN_USE_ERROR) {
    // eslint-disable-next-line max-len
    return EMAIL_IS_IN_USE_NOTIFICATION;
  }
  return errorMsg;
};

class EmailConfigDelete extends PureComponent {
  static propTypes = {
    accountId: PropTypes.string.isRequired,
    organizationId: PropTypes.number.isRequired,
    emailConfigId: PropTypes.number.isRequired,
    showNotification: PropTypes.func.isRequired,
    removeEmailConfig: PropTypes.func.isRequired,
    getAccountEmailConfigs: PropTypes.func.isRequired,
    getOrganizationEmailConfigs: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };

    this.toggle = this.toggle.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  async onSubmit() {
    try {
      await this.props.removeEmailConfig(
        this.props.organizationId,
        { email_config: this.props.emailConfigId, accounts: [this.props.accountId] },
      );
      this.toggle();
      await this.props.getAccountEmailConfigs(this.props.accountId);
      await this.props.getOrganizationEmailConfigs(this.props.organizationId);
      this.props.showNotification('Config deleted successfully');
    } catch (error) {
      if (error.errors) {
        this.props.showNotification(parseErrorResponse(error.errors.error || error.errors.detail), 'danger');
      }
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    return (
      <React.Fragment>
        <MenuItem className="text-danger" onClick={this.toggle}>Remove from account</MenuItem>
        <EmailConfigDeleteConfirm
          isOpen={this.state.isOpen}
          toggle={this.toggle}
          onConfirmClick={this.onSubmit}
        />
      </React.Fragment>
    );
  }
}

export default compose(
  connect(
    state => ({
      config: state.config,
    }),
    { removeEmailConfig, getAccountEmailConfigs, getOrganizationEmailConfigs },
  ),
  withNamespaces('common'),
)(EmailConfigDelete);
